import { render, staticRenderFns } from "./deleteGame.vue?vue&type=template&id=66128e98"
import script from "./deleteGame.vue?vue&type=script&lang=js"
export * from "./deleteGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports